import { useFetchAffiliateInviteDetails } from "@queries/affiliates";
import { AffiliateDetailsResponseDataType } from "@services/http/affiliates";
import { useParams } from "next/navigation";
import { createContext, ReactNode } from "react";

export interface AffiliateContextData {
  data?: AffiliateDetailsResponseDataType;
  isLoading: boolean;
  isError: boolean;
  productUuid: string;
}

export const AffiliateContext = createContext({} as AffiliateContextData);

interface AffiliateProviderProps {
  children: ReactNode;
}

export function AffiliateProvider({ children }: AffiliateProviderProps) {
  const params = useParams<{ uuid: string }>();
  const productUuid = params?.uuid;
  const { data, isError, isLoading } = useFetchAffiliateInviteDetails(productUuid);

  return (
    <AffiliateContext.Provider
      value={{
        data,
        isLoading,
        isError,
        productUuid,
      }}
    >
      {children}
    </AffiliateContext.Provider>
  );
}
